// extracted by mini-css-extract-plugin
module.exports = {"container":"zb","hero":"Ab","content":"Bb","typeProd":"Cb","notTransparent":"Db","sliderDots":"Eb","active":"Fb"};